import feathers from "@feathersjs/client";
import io from "socket.io-client";
import server from "../server";
import { dispatch } from "@rematch/core";
import registerSocketService from "./registerSocketService";

import ServiceProxyFatcory from "./ServiceProxyFactory";

let server_url = process.env.REACT_APP_SOCKET_SERVER_URL;

if (!server_url || server_url === "") {
  server_url = `${window.location.protocol}//${window.location.hostname}`;
  if (window.location.port !== "") {
    server_url = `${server_url}:${window.location.port}`;
  }
}

const socket = io(server_url, {
  transports: ["websocket"],
  upgrade: false,
});

export const app = feathers()
  .configure(
    feathers.socketio(socket, {
      timeout: 350000,
    })
  )
  .configure(
    feathers.authentication({
      storageKey: "feathers-jwt",
      storage: window.localStorage,
    })
  );

registerSocketService(app);
app.service("initiatives").timeout = 50000;
app.service("initiatives/start").timeout = 50000;
app.service("initiatives/activities").timeout = 50000;
app.service("registerAccountUserService").timeout = 20000;

/*
const superagent = require('superagent');
const rest = feathers.rest();

export const app = feathers().configure(rest.superagent(superagent))
    .configure(auth);
*/

export const serviceFatcory = new ServiceProxyFatcory(app);

export const versionService = app.service("version");
export const pricingTableService = app.service("pricingtable");
export const captchaCheckService = app.service("captcha");
export const registerAccountUserService = app.service("/accountusers/register");
export const resetPasswordService = app.service("/accountusers/password");
export const otpCheckService = app.service("/accountusers/otpcheck");
export const verifyEmailService = app.service("/accountusers/verifyemail");
export const autoLoginService = app.service("/accountusers/autologin");
export const autoLoginCompleteService = app.service("/accountusers/autologincomplete");
export const generateOtpService = app.service("/accountusers/otp");
export const loginOtpService = app.service("/login-otp");
export const checkUserService = app.service("/accountusers/emails");
export const activateUserService = app.service("/accountusers/activate");
export const registerUserService = app.service("/accountusers/register");
export const resendConfirmationService = app.service(
  "/accountusers/confirmation"
);
export const unGaurdedCheckUserService = app.service("/accountusers/emails");
export const unGaurdedInvitesService = app.service("/invite/acceptreject");
export const forgetService = app.service("forgetpassword");
export const environmentService = app.service("environment");
export const ssoConfigService = app.service("/ssoconfigs");
export const helpContentService = app.service("helpcontents");
export const emailUnsubscribeService = app.service("/email/unsubscribe");

export const accountUsersService = serviceFatcory.getProxy("/accountusers");
export const accountService = serviceFatcory.getProxy("/accounts", true);
export const accountUserWorkspacesService = serviceFatcory.getProxy(
  "/accountuserworkspaces"
);
export const setDefaultAccountService =
  serviceFatcory.getProxy("/accounts/default");
export const setDefaultWorkspaceService = serviceFatcory.getProxy(
  "/organizations/default"
);
export const setActiveWorkspaceService = serviceFatcory.getProxy(
  "/organizations/active"
);
export const organizationAPIKeyService = serviceFatcory.getProxy(
  "/organizations/apikeys"
);

export const AccountSubscriptionDetailsService = serviceFatcory.getProxy(
  "/accounts/subscriptions"
);
export const accountUpgradeService =
  serviceFatcory.getProxy("accounts/upgrade");
export const accountCountsByPlan = serviceFatcory.getProxy(
  "accounts/getPlanCounts"
);
export const addIntegrationInAccountService = serviceFatcory.getProxy(
  "/accounts/addIntegrations"
);
export const removeIntegrationsFromAccountService = serviceFatcory.getProxy(
  "/accounts/removeIntegration"
);

export const invitesService = serviceFatcory.getProxy("invites");
export const declinedInvitesService =
  serviceFatcory.getProxy("declinedinvites");
export const subOrganizationService =
  serviceFatcory.getProxy("suborganizations");
export const organizationService = serviceFatcory.getProxy("organizations");
export const serachUsersService = serviceFatcory.getProxy("searchusers");
export const searchInviteUsersService =
  serviceFatcory.getProxy("searchinviteusers");
export const mailsenderService = serviceFatcory.getProxy("mailsender");
export const practicesService = serviceFatcory.getProxy("playbooks");
export const practicesSummaryService = serviceFatcory.getProxy(
  "/playbooks/summary/counts"
);
export const communitiesCountService = serviceFatcory.getProxy(
  "/playbooks/count/community"
);
export const activitiesCountService = serviceFatcory.getProxy(
  "/playbooks/count/activity"
);
export const practiceExportService =
  serviceFatcory.getProxy("/playbooks/export");
export const importPracticesService =
  serviceFatcory.getProxy("/playbooks/import");
export const decodePracticesService =
  serviceFatcory.getProxy("/playbooks/decode");
export const playbookCopyService = serviceFatcory.getProxy("/playbooks/copy");
export const playbookVersionService =
  serviceFatcory.getProxy("/playbooks/version");
export const practiceExcelExportService =
  serviceFatcory.getProxy("/playbooks/excel");
export const practiceTemplateDownloadService = serviceFatcory.getProxy(
  "/playbooks/templates"
);
export const practiceWordExportService =
  serviceFatcory.getProxy("/playbooks/word");
export const PracticeActivitySummaryService = serviceFatcory.getProxy(
  "/playbooks/activities/summary"
);
export const publicPlayboooksService =
  serviceFatcory.getProxy("playbooks/public");

export const publishedActivitiesService = serviceFatcory.getProxy(
  "/playbooks/published/activities"
);
export const publishedContentsService = serviceFatcory.getProxy(
  "/contents/published"
);
export const contentsService = serviceFatcory.getProxy(
  "/contents"
);
export const usersWhichPublishedContentService =
  serviceFatcory.getProxy("/contents/users");
export const usersWhichPublishedInitiativesService =
  serviceFatcory.getProxy("/initiatives/users");
export const usersWhichPublishedPlaybookService =
  serviceFatcory.getProxy("/playbooks/users");
export const categoriesService = serviceFatcory.getProxy("categories", true);
export const categoriesExportService =
  serviceFatcory.getProxy("categories/export");
export const categoriesImportService =
  serviceFatcory.getProxy("categories/import");
export const categoriesWorkspaceImportService =
  serviceFatcory.getProxy("categories/import-workspace");
export const categoryPublicService =
  serviceFatcory.getProxy("/categories/public");
export const categoryTreeService = serviceFatcory.getProxy("/categories/tree");
export const categoryPublicTreeService = serviceFatcory.getProxy(
  "/categories/public/tree"
);
export const categoryTreeByAccessService =
  serviceFatcory.getProxy("/categories/access");
export const checkCategoryService =
  serviceFatcory.getProxy("/categories/check");
export const copyCategoryService = serviceFatcory.getProxy("/categories/copy");
export const defaultCategoryService = serviceFatcory.getProxy(
  "/categories/default"
);
export const signUpService = app.service("newsignup");
signUpService.hooks({
  before: {
    all: [
      context => {
        context.params.authenticated = true;
        return context;
      }
    ]
  }
});

export const contentService = serviceFatcory.getProxy("contents");
export const bulkDeleteService = serviceFatcory.getProxy("/bulk/delete");
export const bulkUpdateService = serviceFatcory.getProxy("/bulk/update");
export const publicContentsService = serviceFatcory.getProxy("contents/public");
export const contentsExportService =
  serviceFatcory.getProxy("/contents/export");
export const importContentsService =
  serviceFatcory.getProxy("/contents/import");
export const contentCopyService = serviceFatcory.getProxy("/contents/copy");
export const contentBulkService = serviceFatcory.getProxy("/contents/bulk");
export const decodeContentService = serviceFatcory.getProxy("/contents/decode");
export const contentInitiativeService = serviceFatcory.getProxy(
  "/contents/addinitiativesincontent"
);

export const activitiesService = serviceFatcory.getProxy(
  "playbooks/activities"
);
export const notificationsService = serviceFatcory.getProxy("notifications");
export const systemNotificationService = serviceFatcory.getProxy(
  "systemNotifications"
);
export const accountUserMetadataService = serviceFatcory.getProxy("accountusermetadata")
export const activitiesDndService = serviceFatcory.getProxy(
  "/playbooks/activities/dnd"
);
export const activitiesImportService = serviceFatcory.getProxy(
  "/playbooks/activities/import"
);
export const communitiesDndService = serviceFatcory.getProxy(
  "/playbooks/communities/dnd"
);
export const communitiesService = serviceFatcory.getProxy(
  "playbooks/communities"
);
export const subOrganizationTreeService = serviceFatcory.getProxy(
  "/suborganizations/tree"
);
export const subOrganizationTreeListService = serviceFatcory.getProxy(
  "/suborganizations/treeList"
)
export const usersTreeService = serviceFatcory.getProxy("/accountusers/tree");
export const usersTreeListService = serviceFatcory.getProxy("/accountusers/treeList");
export const subOrganizationByRoleService = serviceFatcory.getProxy(
  "/suborganizations/roles"
);
export const statsService = serviceFatcory.getProxy("stats");

export const initiativeactivitiesDndService = serviceFatcory.getProxy(
  "/initiatives/activities/dnd"
);
export const initiativesService = serviceFatcory.getProxy("initiatives");
export const initiativeActivitiesService = serviceFatcory.getProxy(
  "initiatives/activities"
);
export const initiativeDetailsService = serviceFatcory.getProxy(
  "initiatives/details"
);
export const initiativeCommunitiesService = serviceFatcory.getProxy(
  "initiatives/communities"
);
export const initiativeSubOrgService =
  serviceFatcory.getProxy("initiatives/suborg");
export const startInitiativeService =
  serviceFatcory.getProxy("initiatives/start");
export const restartInitiativeService = serviceFatcory.getProxy(
  "initiatives/restart"
);
export const exportInitiativeService =
  serviceFatcory.getProxy("initiatives/export");
export const upgradeService = serviceFatcory.getProxy("/stripe/upgradepage");
export const createSubscriptionService = serviceFatcory.getProxy("/stripe/create");
export const checkoutSessionService = serviceFatcory.getProxy("/stripe/checkout");
export const customerSessionService = serviceFatcory.getProxy("/stripe/customersession");
export const stripeStatsService = serviceFatcory.getProxy("/stripe/stats");

export const initiativeAssociatedTeamsService =
  serviceFatcory.getProxy("/initiatives/teams");
export const initiativeLeafActivitiesService = serviceFatcory.getProxy(
  "/initiatives/activities/leaves"
);
export const activitiesGroupedByCommunitiesService = serviceFatcory.getProxy(
  "/initiatives/activities/communities"
);
export const initiativeMemberActivitiesService = serviceFatcory.getProxy(
  "/initiatives/myactivities"
);
export const onHoldActivitiesService = serviceFatcory.getProxy(
  "/initiatives/activities/onhold"
);
export const initiativesCountByStatusForMemberService = serviceFatcory.getProxy(
  "/initiatives/member/summary"
);
export const assignAllCommunitiesToOneTeamService = serviceFatcory.getProxy(
  "/initiatives/communities/assign"
);
export const copyTeamStructureService = serviceFatcory.getProxy(
  "/initiatives/communities/copy"
);
export const duplicateActivityService = serviceFatcory.getProxy(
  "/playbooks/activity/duplicate"
);
export const checkSuborganizationBeforeDeleteService = serviceFatcory.getProxy(
  "/suborganizations/checkbeforedelete"
);
export const checkContentBeforeDeleteService = serviceFatcory.getProxy(
  "/contents/checkcontentbeforedelete"
);
export const contentlistService = serviceFatcory.getProxy("contentlist");
export const userCacheService = serviceFatcory.getProxy("/usercache");
export const userAccountCacheService = serviceFatcory.getProxy("/accountcache");
export const userWorkspaceCacheService =
  serviceFatcory.getProxy("/workspacecache");
export const userWorkspaceManagerService =
  serviceFatcory.getProxy("workspaces/users");
export const playbookDependenciesService = serviceFatcory.getProxy(
  "playbooks/activities/dependencies"
);
export const initiativeDependenciesService = serviceFatcory.getProxy(
  "initiatives/activities/dependencies"
);
export const activityRaciusersService = serviceFatcory.getProxy(
  "initiatives/activities/raciusers"
);
export const editInitiativeService =
  serviceFatcory.getProxy("initiatives/edit");
export const copyActivityService = serviceFatcory.getProxy(
  "/initiatives/activities/copy"
);

export const workspaceOwnerDashboardCountervice = serviceFatcory.getProxy(
  "/organization/workspaceowner/dashboard/count"
);
export const managerDashboardCountService = serviceFatcory.getProxy(
  "/organization/manager/dashboard/count"
);
export const accountNotificationsCountService = serviceFatcory.getProxy(
  "/notifications/account/counts"
);
export const workspaceNotificationsCountService = serviceFatcory.getProxy(
  "/notifications/workspace/counts"
);
export const allWorkspaceNotificationsService = serviceFatcory.getProxy(
  "/notifications/workspace/all"
);
export const myNotificationsService =
  serviceFatcory.getProxy("/notifications/my");
export const MarkReadNotificationsService = serviceFatcory.getProxy(
  "/notifications/read"
);

export const templatesService = serviceFatcory.getProxy("/templates");
export const dashboardsService = serviceFatcory.getProxy("/dashboards");
export const dashboardConceptsService = serviceFatcory.getProxy(
  "/dashboards/concepts"
);
export const dashboardEventsService =
  serviceFatcory.getProxy("/dashboards/events");
export const dashboardUsersService =
  serviceFatcory.getProxy("/dashboards/users");

export const tagsService = serviceFatcory.getProxy("/tags", true);
export const tagsTreeService = serviceFatcory.getProxy("/tags/tree");
export const tagUsageService = serviceFatcory.getProxy("/tags/usage");

export const deactivateAccountService = serviceFatcory.getProxy(
  "/accounts/deactivate"
);
export const activateAccountService =
  serviceFatcory.getProxy("/accounts/activate");
export const publicAccessService = serviceFatcory.getProxy("/accounts/public");
export const topUpFreeCreditsService = serviceFatcory.getProxy(
  "/accounts/topup-free-credits"
);
export const usersPermissionsService = serviceFatcory.getProxy(
  "/accountusers/permissions"
);

export const downloadFileService = serviceFatcory.getProxy("/downloads");

export const userTeamsService = serviceFatcory.getProxy("/accountusers/teams");
export const removeUserTeamsService = serviceFatcory.getProxy(
  "/suborganizations/removeuser"
);
export const changeRoleTeamService = serviceFatcory.getProxy(
  "/organizations/changeRole"
);
export const addIntegrationInOrgService = serviceFatcory.getProxy(
  "/organizations/addIntegration"
);
export const removeUserFromOrgService = serviceFatcory.getProxy(
  "/organizations/removeUser"
);
export const deleteUserFromOrgService = serviceFatcory.getProxy(
  "/organizations/deleteUser"
);
export const userPreferencesService =
  serviceFatcory.getProxy("/userpreferences");
export const apiKeyService = serviceFatcory.getProxy("/apikey");

export const integrationsService = serviceFatcory.getProxy("/integrations");
export const integrationsListService =
  serviceFatcory.getProxy("/integrations/list");
export const editIntegrationsService = serviceFatcory.getProxy(
  "/integrations/editIntegrations"
);
export const removeIntegrationService = serviceFatcory.getProxy(
  "/integrations/removeIntegration"
);
export const integrationsProviderService = serviceFatcory.getProxy(
  "/integrations/provider"
);
export const testIntegrationService =
  serviceFatcory.getProxy("/integrations/test");
export const entityIntegrationService = serviceFatcory.getProxy(
  "/integrations/entities"
);
export const entityIntegrationConfigService = serviceFatcory.getProxy(
  "/entityintegrations"
);
export const JiraService = serviceFatcory.getProxy("/jira/list");
export const makeService = serviceFatcory.getProxy("/make/token");
export const makeAllScenariosService = serviceFatcory.getProxy("/make/scenarios");
export const GetScenarioInputs = serviceFatcory.getProxy("/make/scenario/inputs");
export const RunScenario = serviceFatcory.getProxy("/make/scenario/run");
export const customTemplateActionService =
  serviceFatcory.getProxy("/customtemplates");
export const subInitiativeService = serviceFatcory.getProxy("/initiatives/sub");
export const suborganizationsExportService = serviceFatcory.getProxy(
  "/suborganizations/export"
);
export const suborganizationsImportService = serviceFatcory.getProxy(
  "/suborganizations/import"
);
export const workspaceMetadataService =
  serviceFatcory.getProxy("/workspacemetadata"); // Added for workspace metadata KLM-8948

export const playbookMetadataService = serviceFatcory.getProxy(
  "/playbook/updatemetadata"
);
export const dataProcessorImageService = serviceFatcory.getProxy(
  "/dataProcessor/images"
);
export const dataProcessorDescriptionService = serviceFatcory.getProxy(
  "/dataProcessor/description"
);
export const dataProcessorRolesService = serviceFatcory.getProxy(
  "/dataProcessor/roles"
);
export const dataProcessorStageService = serviceFatcory.getProxy(
  "/dataProcessor/stages"
);
export const dataProcessorLeafNodeActivitiesService = serviceFatcory.getProxy(
  "/dataProcessor/playbooks"
);
export const dataProcessorWebSearchService = serviceFatcory.getProxy(
  "/dataProcessor/websearch"
);
export const dataProcessorActivitiesService = serviceFatcory.getProxy(
  "/dataProcessor/activities"
);
export const dataProcessorAllWebSearchService = serviceFatcory.getProxy(
  "/dataProcessor/websearch/all"
);
export const dataProcessorPlaybookNameService = serviceFatcory.getProxy(
  "/dataProcessor/playbook/name"
);
export const activityActionsService = serviceFatcory.getProxy(
  "/playbook/activity/actions"
);
export const initiativeActivityActionsService = serviceFatcory.getProxy(
  "/initiative/activity/actions"
);
export const entityFieldMappingService = serviceFatcory.getProxy(
  "/entityfieldmapping"
);
export const GetMyPlaybooksFromAllAccountsAndWorkspacesService =
  serviceFatcory.getProxy("/playbooks/all/accounts/workspaces");
export const GetConsumptionDetailsService = serviceFatcory.getProxy("/eventlogs/consumptiondetails");
export const ExportConsumptionDetailsExcelService = serviceFatcory.getProxy("/eventlogs/consumptionexport");
export const ConsumptionBillingService = serviceFatcory.getProxy("/consumptionbillings");
export const AccountsUsageService = serviceFatcory.getProxy("/accountsUsage");